// startup
// Load entry module and return exports
// This entry module depends on other loaded chunks and execution need to be delayed
var __webpack_exports__ = __webpack_require__.O(undefined, ["vendors-node_modules_fortawesome_fontawesome-free_css_brands_css-node_modules_fortawesome_fon-850913","src_common_main-ui_analytics_analytics_js-src_common_main-ui_commonImports_js"], () => (__webpack_require__("./src/pages/js/home-page.js")))
__webpack_exports__ = __webpack_require__.O(__webpack_exports__);
